/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProjectModel } from '../models/project-model';

@Injectable({
  providedIn: 'root',
})
export class DbDiagramNodeProjectModelControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation dbDiagramNodeProjectModelControllerGetProjectModel
   */
  static readonly DbDiagramNodeProjectModelControllerGetProjectModelPath = '/db-diagram-nodes/{id}/project-model';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProjectModel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectModel$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<Array<ProjectModel>>> {

    const rb = new RequestBuilder(this.rootUrl, DbDiagramNodeProjectModelControllerService.DbDiagramNodeProjectModelControllerGetProjectModelPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectModel>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProjectModel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProjectModel(params: {
    id: string;
  }): Observable<Array<ProjectModel>> {

    return this.getProjectModel$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectModel>>) => r.body as Array<ProjectModel>)
    );
  }

}
